<template>
  <div v-if="items && items.length">
    <ul class="flex flex-col gap-y-6 leading-none">
      <li
        v-for="item in visibleItems"
        :key="item.id"
        class="flex w-full items-center"
      >
        <span class="mr-4 h-6 w-6 shrink-0 text-red">
          <UiIcon icon="pdfFile" container-size />
        </span>

        <UiLink
          :download="item.name"
          :to="filterLink(item.file)"
          class="flex-grow text-md font-bold text-blue"
        >
          <span v-html="item.name" />
        </UiLink>
      </li>
    </ul>

    <UiButton
      v-if="!showAll && hiddenItems"
      outlined
      variant="secondary"
      class="mt-6"
      @click="showAllItems"
    >
      {{ $t('show_more') }} ({{ hiddenItems }})
    </UiButton>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import type { DocumentItem } from '@webplatform/frontkit/runtime/types';

interface Props {
  items?: DocumentItem[];
}

const props = withDefaults(defineProps<Props>(), {
  items: () => [],
});

const { fullPath } = useRuntimeConfig().public.frontkit;

const limit = ref(5);
const showAll = ref(false);
const visibleItems = computed(() =>
  showAll.value ? props.items : props.items?.slice(0, limit.value),
);
const hiddenItems = computed(() =>
  Math.max(0, (props.items?.length || 0) - limit.value),
);

const filterLink = (path: string) => {
  const isExternalLink = /^https?:/.test(path);

  if (isExternalLink) {
    return path;
  }

  return `${fullPath}${path}`;
};

const showAllItems = () => {
  showAll.value = true;
};
</script>
